import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { Typography, withStyles } from '@material-ui/core';
import Loader from '../Layout/Loader';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import KobooTablePagination from '../Layout/KobooTablePagination';
import LldWaitingUsersRow from './LldWaitingUsersRow';
import { connect } from 'react-redux';
import { compose } from 'recompose';

const columnData = [
  {
    id: 'created_at', numeric: true, disablePadding: true, label: 'Date de la demande',
  },
  {
    id: 'last_name', numeric: false, disablePadding: false, label: 'Nom',
  },
  {
    id: 'first_name', numeric: false, disablePadding: false, label: 'Prénom',
  },
  {
    id: 'phone', numeric: true, disablePadding: false, label: 'Téléphone',
  },
  {
    id: 'city', numeric: false, disablePadding: false, label: 'Ville',
  },
  {
    id: 'start_date', numeric: true, disablePadding: false, label: 'Date de location',
  },
  {
    id: 'location_duration',
    numeric: true,
    disablePadding: false,
    label: 'Durée de la location',
  },
  /* Bike availability not implemented yet
  {
    id: 'bike_availability', numeric: false, disablePadding: false, label: 'Disponibilité du vélo',
  },
  */
  {
    id: 'delete', numeric: false, disablePadding: false, label: 'Supprimer',
  },
];

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});

const objectsToTableData = (objects) => {
  return objects.map(obj => {
      return {
        id: obj.id,
        phone: obj.phone,
        lastname: obj.lastname,
        firstname: obj.firstname,
        city: obj.city,
        start_date: obj.start_date,
        created_at: obj.created_at,
        lldCount: obj.lldCount,
        lldType: obj.lldType,
        original: obj,
      };
    },
  );
};

const LldWaitingUsersTable = (props) => {
  const { lldWaitingUsers, pending, classes, openDialog, authUser, error } = props;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('date');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(objectsToTableData(props.lldWaitingUsers));
    sortTableData();
  }, [lldWaitingUsers]);

  const sortTableData = () => {
    tableData.sort((firstEl, secondEl) => {
      if (firstEl[orderBy] < secondEl[orderBy]) {
        return -1;
      } else if (firstEl[orderBy] > secondEl[orderBy]) {
        return 1;
      }
      return 0;
    });
    if (order === 'desc') {
      tableData.reverse();
    }
  };

  const handleChangeOrder = property => {
    const newOrderBy = property;
    let newOrder = 'asc';
    if (orderBy === newOrderBy && order === newOrder) {
      newOrder = 'desc';
    }
    setOrder(newOrder);
    setOrderBy(newOrderBy);
  };

  const handleChangePage = page => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  if (pending) {
    return (
      <Loader />
    );
  } else if (lldWaitingUsers && lldWaitingUsers.length > 0) {
    sortTableData();
    return (
      <React.Fragment>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columnData.map(column => (
                <TableCell
                  key={column.id}
                  padding={column.disablePadding ? 'none' : 'normal'}
                  sortDirection={orderBy === column.id ? order : false}
                >
                  <Tooltip
                    title="Trier"
                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}>
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={order}
                      onClick={() => handleChangeOrder(column.id)}>
                      {column.label}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              ), this)}
              <TableCell padding="checkbox">
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.slice(
              page * rowsPerPage,
              (page * rowsPerPage) + rowsPerPage,
            ).map(lldWaitingUser => (
              <LldWaitingUsersRow
                key={lldWaitingUser.id}
                lldWaitingUser={lldWaitingUser}
                authUser={authUser}
                error={error}
                openDialog={openDialog}
              />
            ))}
          </TableBody>
        </Table>
        <KobooTablePagination
          numberOfItems={lldWaitingUsers.length}
          rowsPerPage={rowsPerPage}
          label="Réservations par page"
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
  } else {
    return (
      <Typography variant="subtitle1">Aucune réservation en liste d'attente</Typography>
    );
  }
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    error: state.lldWaitingUsers.error,
  };
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(LldWaitingUsersTable);



// WEBPACK FOOTER //
// ./src/components/BookingsLld/LldWaitingUsersTable.jsx